<template>
  <VModalWidget :dismiss="dismiss" :loading="loading">
    <template slot="title">{{ $t('title') }}</template>

    <template slot="footer-actions">
      <AddUserGroupAttribution :handleSubmit="add" />
    </template>

    <template slot="content" v-if="loading">
      <v-loading />
    </template>
    <template slot="content" v-else>
      <v-text-field
        v-model="search"
        :placeholder="$t('labels.search')"
        :append-icon="$vuetify.icons.values.search"
        clearable
      />
      <v-data-table
        flat
        :search="search"
        :headers="headers"
        :items="members"
        hide-default-header
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:item="{ item }">
          <UserLine :user="item" :add="add" :destroy="destroy" />
        </template>
      </v-data-table>
    </template>
  </VModalWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { addPrincipalInfo } from '../../utils'
import { NAMESPACE } from '../store'
import { NAMESPACE as USER_NAMESPACE } from '@argon/iam/users/store'
import { NAMESPACE as GROUP_NAMESPACE } from '@argon/iam/groups/store'
import { NAMESPACE as ATTR_NAMESPACE } from '@argon/iam/attributions/store'
import { VModalWidget, VLoading } from '@argon/app/components'
import { AddUserGroupAttribution, UserLine } from '@argon/iam/components'
export default {
  name: 'BoardUsersWidget',
  components: {
    VModalWidget,
    VLoading,
    AddUserGroupAttribution,
    UserLine
  },
  props: {
    boardRef: { type: String, required: true },
    dismiss: { type: Function, required: true }
  },
  data: () => ({
    headers: [{ value: 'icon' }, { value: 'display' }, { value: 'attributionName' }, { value: 'actions' }],
    search: '',
    loading: true
  }),
  computed: {
    ...mapState(NAMESPACE, ['board', 'principals']),
    ...mapState(USER_NAMESPACE, ['users']),
    ...mapState(GROUP_NAMESPACE, ['groups']),
    ...mapState(ATTR_NAMESPACE, ['attributions']),
    members() {
      let matchedUsers = addPrincipalInfo(this.users, this.principals, this.attributions, 'user')
      let matchedGroups = addPrincipalInfo(this.groups, this.principals, this.attributions, 'group')
      return [...matchedUsers, ...matchedGroups]
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listPrincipals', 'addPrincipals', 'deletePrincipals']),
    ...mapActions(USER_NAMESPACE, ['listUsers']),
    ...mapActions(GROUP_NAMESPACE, ['listGroups']),
    ...mapActions(ATTR_NAMESPACE, ['listAttributions']),
    add(payload) {
      return this.addPrincipals({ ...payload, boardRef: this.boardRef })
    },
    destroy(payload) {
      return this.deletePrincipals({
        principalIds: [payload],
        boardRef: this.boardRef
      })
    }
  },
  mounted() {
    Promise.all([this.listUsers({}), this.listGroups({}), this.listAttributions(), this.listPrincipals(this.boardRef)])
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Users"
  },
  "fr": {
    "title": "Usagers"
  }
}
</i18n>
